import React from 'react'
import { Route, Router, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import { Toaster } from '@CommonComponents/toast'
import { Details } from './Details'
import { ReportPage } from './Reporting'
import { InvoiceAccountsPage } from './InvoiceAccounts'

export const history = createBrowserHistory()

export const App = props => {
  const initialState = {
    invoiceAccts: props.invoiceAccts,
    breakdown: [],
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'setInvoiceAccts':
        return {
          ...state,
          invoiceAccts: action.payload,
        }
      case 'setBreakdownData':
        return {
          ...state,
          breakdown: action.payload,
        }
      case 'reset':
        return {
          ...state,
          coursenumToCopy: '',
        }
    }
  }

  const baseURL = '/account/invoice_account_enrollment'

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <div className="container col-lg-24 mt-5">
        <Router history={history}>
          <Switch>
            <Route exact path={`${baseURL}/reporting`} component={ReportPage} />
            <Route
              exact
              path={`${baseURL}/invoice_accounts`}
              component={InvoiceAccountsPage}
            />
            <Route
              exact
              path={`${baseURL}/invoice_accounts/details/:acctId`}
              component={Details}
            />
            <Route path="*" component={ReportPage} />
          </Switch>
        </Router>
      </div>
    </StateProvider>
  )
}
